export const PARTNER_EMAIL = 'partnerships@chisme.social';

/** The business portal, where businesses sign up and pay themselves. */
export const BUSINESS_PORTAL_URL = 'https://business.chisme.social/';

/** "Registrar mi negocio": the portal, tagged so PostHog sees where they came from. */
export const PARTNER_REGISTER_URL = `${BUSINESS_PORTAL_URL}?utm_source=chisme.social&utm_medium=partners_page`;

export const PARTNERS_PAGE_URL = 'https://partners.chisme.social/';

export const PARTNERS_HOW_IT_WORKS_ID = 'como-funciona';

export const PARTNERS_IMAGES = {
  heroBusiness: '/images/business/Chisme-business.png',
} as const;
